import { createRouter, createWebHistory } from 'vue-router'
import Home from '@/views/Home.vue'
import { isLoggedIn } from '@/utils/auth'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue')
  },
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { requiresAuth: true }
  },
  {
    path: '/event/:id',
    name: 'EventDetail',
    component: () => import('@/views/EventDetail.vue'),
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/event/:id/photos',
    name: 'PhotoWall',
    component: () => import('@/views/PhotoWall.vue'),
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('@/views/About.vue'),
    meta: { requiresAuth: true }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 }
  }
})

// 路由守卫 - 检查简单 Session 状态
router.beforeEach((to, from, next) => {
  const authenticated = isLoggedIn()

  if (to.meta.requiresAuth && !authenticated) {
    next('/login')
  } else if (to.path === '/login' && authenticated) {
    next('/')
  } else {
    next()
  }
})

export default router
